<div class="agent-dashboard-container">
  <div class="row">
    <div class="col-xs-6">
      <div class="box">
        <mat-card>
          <app-doughnut-chart></app-doughnut-chart>
        </mat-card>
      </div>
    </div>
    <div class="col-xs-6">
      <div class="box">
        <mat-card>
          <app-pie-chart></app-pie-chart>
        </mat-card>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="box">
        <mat-card>
          <app-line-chart></app-line-chart>
        </mat-card>
      </div>
    </div>
  </div>
</div>
